import { RedeemCheckboxProps, RedeemProductProps, Styled } from './';
import { FiPlus } from 'react-icons/fi';
import { Checkbox } from 'components/core/Checkbox';
import { useI18n } from 'contexts/i18n';

export const RedeemPoints = ({ redeemProduct }: RedeemProductProps) => {
  const i18n = useI18n();
  return (
    <Styled.RedeemContainer>
      <Styled.InputContainer>
        <Styled.Price>{redeemProduct?.displayPriceWithPoints}</Styled.Price>
      </Styled.InputContainer>

      <Styled.RedeemPlusContainer>
        <FiPlus size={18} />
      </Styled.RedeemPlusContainer>

      <Styled.InputContainer>
        <Styled.RedeemPoints wide>
          {redeemProduct?.points} {i18n['Points Redeemed']}
        </Styled.RedeemPoints>
      </Styled.InputContainer>
    </Styled.RedeemContainer>
  );
};

export const RedeemCheckbox = ({ checked, onChange }: RedeemCheckboxProps) => {
  const i18n = useI18n();
  return (
    <Styled.RedeemCheckboxContainer>
      <Checkbox
        label={i18n['Use Rewards points to redeem']}
        checked={checked}
        onChange={onChange}
      />
    </Styled.RedeemCheckboxContainer>
  );
};
